module.exports = __webpack_public_path__ + "media/images/area/area_ibarakiM400-d9d6d2eec187ff9e5b201e8ec0f35108.jpg";